import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SolarApplicationsService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  private createCompleteUrl(path: string): string {
    return `${this.apiUrl}${path}`;
  }

  // Create a new solar request
  createSolarRequest(data: any): Observable<any> {
    return this.http.post<any>(this.createCompleteUrl('solar/solar-applications'), data);
  }

  getApplicationsReceived(limit: number = 10, offset: number = 0, applicationStateId?: number, filter?: string): Observable<any> {
    let params = new HttpParams()
      .set('limit', limit.toString())
      .set('offset', offset.toString());
    
    if (applicationStateId) {
      params = params.set('application_state_id', applicationStateId.toString());
    }
  
    if (filter) {
      params = params.set('filter_word', filter);
    }
  
    return this.http.get<any>(this.createCompleteUrl('solar/solar-applications/list'), { params });
  }

  // Get solar request for the authenticated user
  getCurrentUserSolarRequest(): Observable<any> {
    return this.http.get<any>(this.createCompleteUrl('solar/solar-applications'));
  }

  // Get summary of states
  getApplicationsStates(): Observable<any> {
    return this.http.get<any>(this.createCompleteUrl('solar/solar-applications/states-summary'));
  }

  // Get solar request for a specific user
  getUserSolarRequest(userId: string): Observable<any> {
    return this.http.get<any>(this.createCompleteUrl(`solar/solar-applications/${userId}`));
  }

  updateSolarRequestState(userId: string, newStateId: number): Observable<any> {
    const data = {
      user_id: userId,
      new_state_id: newStateId
    };
    return this.http.post<any>(this.createCompleteUrl('solar/solar-applications/update-state'), data);
  }

  resetSolarRequest(solarApplicationId: string): Observable<any> {
    const params = new HttpParams().set('solar_application_id', solarApplicationId);
    return this.http.post<any>(this.createCompleteUrl('solar/solar-applications/reset'), null, { params });
  }

  getUsersGroupedByType(): Observable<any> {
    return this.http.get<any>(this.createCompleteUrl('users/count'));
  }
  
}